import React, { useState, useEffect } from "react";
import "./Wishlist.css";
import API_URL from "../apiConfig";

const API_BASE_URL = API_URL;

const Wishlist = ({ onBack, onProductClick }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  useEffect(() => {
    if (user) {
      fetchWishlist();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchWishlist = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/wishlist`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      setItems(data.products || []);
    } catch (err) {
      console.error("Fetch wishlist error:", err);
    } finally {
      setLoading(false);
    }
  };

  const removeFromWishlist = async (productId) => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/wishlist/toggle`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ productId }),
      });
      if (res.ok) {
        const updated = await res.json();
        setItems(updated.products || []);
      }
    } catch (err) {
      console.error("Remove wishlist error:", err);
    }
  };

  if (loading)
    return (
      <div className="wishlist-empty container">
        <h2>Loading Wishlist...</h2>
      </div>
    );

  if (!user)
    return (
      <div className="wishlist-empty container">
        <h2>Please login to view your wishlist</h2>
        <button
          className="shop-now-btn"
          style={{ marginTop: "20px" }}
          onClick={onBack}
        >
          LOGIN NOW
        </button>
      </div>
    );

  if (items.length === 0)
    return (
      <div className="wishlist-empty container">
        <h2>YOUR WISHLIST IS EMPTY</h2>
        <p>
          Add items that you like to your wishlist. Review them anytime and
          easily move them to the bag.
        </p>
        <img
          src="https://a.vpimg.com/a/common/index/empty_wishlist.png"
          alt="Empty Wishlist"
          style={{ width: "150px", margin: "30px 0", opacity: 0.5 }}
        />
        <button className="continue-shopping-btn" onClick={onBack}>
          CONTINUE SHOPPING
        </button>
      </div>
    );

  return (
    <div className="wishlist-page container">
      <div className="wishlist-header">
        <h3>
          My Wishlist <span>{items.length} Items</span>
        </h3>
      </div>

      <div className="wishlist-grid">
        {items.map((product) => (
          <div key={product._id} className="wishlist-card">
            <div
              className="wishlist-image"
              onClick={() => onProductClick(product)}
            >
              <img
                src={
                  product.images?.[0]?.startsWith("http")
                    ? product.images[0]
                    : `${API_BASE_URL}${product.images?.[0]}`
                }
                alt={product.name}
              />
              <button
                className="remove-wishlist-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  removeFromWishlist(product._id);
                }}
              >
                ✕
              </button>
            </div>
            <div className="wishlist-info">
              <p className="w-name">{product.name}</p>
              <div className="w-pricing">
                <span className="w-curr-price">₹{product.price}</span>
                {product.originalPrice > product.price && (
                  <span className="w-old-price">₹{product.originalPrice}</span>
                )}
                {product.originalPrice > product.price && (
                  <span className="w-discount">
                    (
                    {Math.round(
                      ((product.originalPrice - product.price) /
                        product.originalPrice) *
                        100,
                    )}
                    % OFF)
                  </span>
                )}
              </div>
            </div>
            <button
              className="move-to-bag-btn"
              onClick={() => onProductClick(product)}
            >
              MOVE TO BAG
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wishlist;
